import { Component, EventEmitter, Output, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {  DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { DatePipe,DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
export const MY_FORMATS  ={
  parse: {dateInput: "DD-MM-YYYY"},
  display: {dateInput: "DD-MM-YYYY ",monthYearLabel: "MMM YYYY",dateA11yLabel: "LL", monthYearA11yLabel: "MMMM YYYY"}
};

@Component({
  selector: 'app-nuevo-area',
  templateUrl: './nuevo-area.component.html',
  styleUrls: ['./nuevo-area.component.scss'],
  providers: [DatePipe,DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class NuevoAreaComponent   {
  @Output() cerrarPopupArea: EventEmitter<boolean>;
  @Input() TableMeta: any;

  MetaArray : any[] = [];

  constructor(private decimalPipe: DecimalPipe, private datePipe: DatePipe) { 
    this.cerrarPopupArea = new EventEmitter();
  }



  onMetaAgregada(meta: any){
    this.MetaArray.push(meta.value);
  } 

  MetcerrarPopupArea(){
    this.cerrarPopupArea.emit();
  }
  
}

